/**
 * P7 — SAP Fiori floorplan → AMAN ADS template registry.
 * Pages pick one floorplan; do not invent parallel page chrome.
 *
 * @see docs/AMAN-ERP-DESIGN-LANGUAGE.md §7
 */

export const FLOORPLAN = {
  /** Toolbar + optional KPIs + filters + table (Sales, Customers, …) */
  LIST_REPORT: 'list-report',
  /** KPI / section-nav + analytical filters + table panels (Reports) */
  ANALYTICAL_LIST: 'analytical-list',
  /** Entity detail / editor with sections + sticky actions */
  OBJECT_PAGE: 'object-page',
  /** Status strip + KPI row + primary content (Admin, Manager overview) */
  OVERVIEW: 'overview',
  /** Side nav + content panels (Settings) */
  SETTINGS: 'settings',
  /** Primary work surface + secondary rail (POS — POS-DESIGN-CONSTITUTION) */
  OPERATIONAL: 'operational',
};

/** @typedef {typeof FLOORPLAN[keyof typeof FLOORPLAN]} FloorplanId */

export const FLOORPLAN_TEMPLATE = {
  [FLOORPLAN.LIST_REPORT]: 'ListPageTemplate',
  [FLOORPLAN.ANALYTICAL_LIST]: 'AnalyticalListPageTemplate',
  [FLOORPLAN.OBJECT_PAGE]: 'ObjectPageTemplate',
  [FLOORPLAN.OVERVIEW]: 'DashboardPageTemplate',
  [FLOORPLAN.SETTINGS]: 'SettingsTemplate',
  [FLOORPLAN.OPERATIONAL]: 'WorkspacePageTemplate',
};
